import * as Yup from 'yup';

export const SignInSchema = Yup.object().shape({
  email: Yup.string().email().required('Email is required'),
  password: Yup.string().min(8).required('please provide your password'),
});

export type SignInDataType = Yup.InferType<typeof SignInSchema>;

type InitialValues = {
  email: string;
  password: string;
};

export const signinInitialValues: InitialValues = {
  email: '',
  password: '',
};

export interface IUserData {
  // id: string,
  // email: string,
  // firstName: string,
  // lastName: string,
  // phoneNumber: string,
  // username: string,
  // role: string,
  // verified: true,
  // enabled: true;

  id: string,
  firstName: string,
  lastName: string,
  email: string,
  accountRole: string,
  role: string,
  verificationStatus: string,
  createdAt: string,
  updatedAt: string,
  phoneNumber: string,
  profilePicture: string,
  companyId: string,
  gender: string;
}

interface IToken {
  token: string,
  expiryTimeInMinutes: number;
}

export interface ISignInData {
  user: IUserData;
  accessToken: IToken;
  refreshToken: IToken;
}
